import baseApi from "./RootBaseApi";
import {
  ExternalService,
  HealthCheck,
  PaginatedExternalServiceResponse,
  ExternalServiceErrorResponse,
} from "@/types/externalApiService.types";
import { Statuses } from "@/constant";

export const ExternalAPIServices = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllExternalServices: builder.query<
      PaginatedExternalServiceResponse,
      void
    >({
      query: () => ({
        url: "third-party-services",
        method: "GET",
      }),
      transformResponse: (response: PaginatedExternalServiceResponse) =>
        response,
      providesTags: [{ type: "ExternalServices", id: "LIST" }],
    }),

    updateExternalService: builder.mutation<
      ExternalService,
      { type_id: number; status: Statuses }
    >({
      query: ({ type_id, status }) => ({
        url: `third-party-services`,
        method: "PATCH",
        params: { type_id },
        data: { status },
      }),
      invalidatesTags: [{ type: "ExternalServices", id: "LIST" }],
    }),

    getHealthCheck: builder.query<HealthCheck[], void>({
      query: () => ({
        url: "third-party-services/health",
        method: "GET",
      }),
      transformResponse: (response: HealthCheck[]) => response,
      providesTags: [{ type: "HealthCheck", id: "LIST" }],
    }),

    // Accepts an error id and returns either a single error
    // or the service wrapper with third_party_error array
    getExternalServiceError: builder.query<
      ExternalServiceErrorResponse,
      string
    >({
      query: (id) => ({
        url: `third-party-services/${id}`,
        method: "GET",
      }),
      transformResponse: (response: ExternalServiceErrorResponse) => response,
    }),
  }),
});

export const {
  useGetAllExternalServicesQuery,
  useUpdateExternalServiceMutation,
  useGetHealthCheckQuery,
  useGetExternalServiceErrorQuery,
  useLazyGetExternalServiceErrorQuery,
} = ExternalAPIServices;
